import React from 'react';
import locale from '@/locale';
import { useI18n, withI18n } from 'panda-i18n';
import { hide as hideMessage, show as showMessage } from '../cn-message/func';
import './index.scss';
import { Indicator } from './indicator';
const CnLoadingToast = withI18n(() => {
    const $i18n = useI18n();
    return (React.createElement("div", { className: "cn-ui-m-loading-toast" },
        React.createElement("div", { className: "cn-ui-m-loading-anim" },
            React.createElement(Indicator, null)),
        React.createElement("div", { className: "cn-ui-m-loading-text" }, $i18n.get({ id: 'Loading', dm: '加载中' }))));
}, { locale, componentName: 'CnLoading' });
export const show = (config = {}) => {
    showMessage({
        type: 'loading',
        custRender: React.createElement(CnLoadingToast, null),
        ...config,
    });
};
export const hide = () => {
    hideMessage();
};
